import { DateTime } from "luxon";

// US clinics show date of birth in the US numeric convention (MM/DD/YYYY).
// Sweden and the UK keep the existing day-first long form ("20 July 2026").
export function formatDateOfBirth(
  date: DateTime,
  countryCode: string | undefined
): string {
  return countryCode === "US"
    ? date.toFormat("MM/dd/yyyy")
    : date.toFormat("d MMMM yyyy");
}
